import { render, staticRenderFns } from "./TablePopupDtableItem.vue?vue&type=template&id=008da8cb&scoped=true"
import script from "./TablePopupDtableItem.vue?vue&type=script&lang=js"
export * from "./TablePopupDtableItem.vue?vue&type=script&lang=js"
import style0 from "./TablePopupDtableItem.vue?vue&type=style&index=0&id=008da8cb&scoped=true&lang=css"
import style1 from "./TablePopupDtableItem.vue?vue&type=style&index=1&id=008da8cb&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008da8cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('008da8cb')) {
      api.createRecord('008da8cb', component.options)
    } else {
      api.reload('008da8cb', component.options)
    }
    module.hot.accept("./TablePopupDtableItem.vue?vue&type=template&id=008da8cb&scoped=true", function () {
      api.rerender('008da8cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/tableComp/tableItems/TablePopupDtableItem.vue"
export default component.exports